"use client";

import { useQuery, useSuspenseQuery } from "@tanstack/react-query";

import { viewerContextQueryOptions } from "@/lib/viewer-context";

export function useViewerQuery() {
  return useQuery(viewerContextQueryOptions());
}

export function useViewer() {
  return useSuspenseQuery(viewerContextQueryOptions()).data;
}
